import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SelectField from './SelectField';

const ACTIVE = 'active'
const INACTIVE = 'inactive'

class InterlockField extends Component {
    _getOptions () {
        // display active interlock options
        const activeList = this.props.interlockList.filter(o => o.status === ACTIVE)

        // add option for previously selected, now inactive, interlock (editing mode only)
        if (this.props.entry.interlockId &&
            !activeList.some(o => o.interlockId === this.props.entry.interlockId)
        ) {
            const selectedInterlock = this.props.interlockList.find(o => o.interlockId === this.props.entry.interlockId)
            if (selectedInterlock) {
                if (selectedInterlock.status === INACTIVE && selectedInterlock.interlockName.indexOf(INACTIVE) === -1) {
                    selectedInterlock.interlockName = `${selectedInterlock.interlockName} (inactive)`
                }
                activeList.push(selectedInterlock)
            }
        }

        activeList.sort((a, b) => a.interlockName.localeCompare(b.interlockName))

        return activeList.map((o) => ({
            label: o.interlockName,
            value: o.interlockId,
            ref: o
        }));
    }

    _getPlaceholder () {
        return "Select interlock";
    }

    _renderInterlock (interlock) {
        return (
            <div>
                <div>{interlock.interlockName}</div>
            </div>
        );
    }

    _hasError () {
        if (this.props.error) {
            return true;
        }

        return this.props.fieldPermission === 'required'
            && this.props.interlockList.length === 0;
    }

    render () {
        return (
            <SelectField
                colClass={this.props.colClass}
                disabled={this.props.interlockList.length === 0}
                hasError={this._hasError()}
                hidden={this.props.fieldPermission === 'hidden'}
                label="Interlock"
                onChange={(option) => this.props.onSelectInterlock(option)}
                optionRenderer={({ ref }) => this._renderInterlock(ref)}
                options={this._getOptions()}
                placeholder={this._getPlaceholder()}
                required={this.props.fieldPermission === 'required'}
                value={(this.props.entry.interlock) ? this.props.entry.interlock.interlockId : null}
                valueRenderer={({ ref }) => ref.interlockName }
            />
        );
    }
}


InterlockField.propTypes = {
    colClass: PropTypes.string.isRequired,
    entry: PropTypes.object.isRequired,
    fieldPermission: PropTypes.string.isRequired,
    hasError: PropTypes.bool.isRequired,
    onSelectInterlock: PropTypes.func.isRequired,
    interlockList: PropTypes.array.isRequired,
};


export default InterlockField;



// WEBPACK FOOTER //
// ./app/components/TimeInput/InputTypes/InterlockField.jsx